import { gql } from "@apollo/client";

export const customerMasterData = {
  customerCode: "",
  customerName: "",
  customerCategory: "",
  status: "",
  creditLimit: "",
  creditPeriod: "",
  addresses: [
    { name: "", lat: "", lng: "", status: true },
    { name: "", lat: "", lng: "", status: true },
    { name: "", lat: "", lng: "", status: true },
    { name: "", lat: "", lng: "", status: true },
  ],
  customerCodeStatus: "unchecked",
  customerNameStatus: "unchecked",
  customerCategoryStatus: "unchecked",
  statusStatus: "unchecked",
  creditLimitStatus: "unchecked",
  creditPeriodStatus: "unchecked",
};

export const customerDataManage = (state, action) => {
  const { name, value } = action;

  switch (name) {
    case "customerCode":
      return {
        ...state,
        customerCode: value,
        customerCodeStatus: value ? "success" : "unchecked",
      };

    case "customerName": {
      const alphaNumericNameRegex = /^[A-Za-z0-9 ]{1,500}$/;
      if (alphaNumericNameRegex.test(value)) {
        return {
          ...state,
          customerName: value,
          customerNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          customerName: "",
          customerNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          customerName: value,
          customerNameStatus: "error",
        };
      }
    }

    case "customerCategory":
      return {
        ...state,
        customerCategory: value,
        customerCategoryStatus: value ? "success" : "unchecked",
      };

    case "status":
      return {
        ...state,
        status: value,
        statusStatus: value ? "success" : "unchecked",
      };

    case "creditLimit":
      return {
        ...state,
        creditLimit: value,
        creditLimitStatus: value ? "success" : "unchecked",
      };

    case "creditPeriod":
      return {
        ...state,
        creditPeriod: value,
        creditPeriodStatus: value ? "success" : "unchecked",
      };

    case "addresses":
      return { ...state, addresses: value };

    case "updateAddress":
      return {
        ...state,
        addresses: state.addresses.map((addr, idx) =>
          idx === value.index
            ? { ...addr, lat: value.lat, lng: value.lng, name: value.name }
            : addr
        ),
      };

    case "updateAddressName":
      return {
        ...state,
        addresses: state.addresses.map((addr, idx) =>
          idx === value.index ? { ...addr, name: value.name } : addr
        ),
      };

    default:
      return state;
  }
};

export const createCustomerMaster = gql`
  mutation CreateCustomerMaster($input: CreateCustomerMasterInput!) {
    createCustomerMaster(input: $input) {
      success
      message
      error
      data {
        id
        customerCode
        customerName
        customerCategory
        status
        creditLimit
        creditPeriod
        createdAt
        addresses {
          id
          address
          latitude
          longitude
        }
      }
    }
  }
`;

export const updateCustomerMaster = gql`
  mutation UpdateCustomerMaster($input: UpdateCustomerMasterInput!) {
    updateCustomerMaster(input: $input) {
      success
      message
      error
      data {
        id
        customerCode
        customerName
        customerCategory
        status
        creditLimit
        creditPeriod
        createdBy
        addresses {
          id
          address
          latitude
          longitude
        }
      }
    }
  }
`;

export const uploadCustomerMaster = gql`
  mutation UploadCustomerMaster($file: Upload!, $userId: Int!) {
    uploadCustomerMaster(file: $file, userId: $userId) {
      success
      error
      message
    }
  }
`;

export const deleteCustomerMaster = gql`
  mutation DeleteCustomerMaster($id: ID!) {
    deleteCustomerMaster(id: $id) {
      success
      message
      error
    }
  }
`;

export const getAllCustomermaster = gql`
  query GetAllCustomerMaster($page: Int, $pageSize: Int, $search: String) {
    getAllCustomermaster(page: $page, pageSize: $pageSize, search: $search) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        customerCode
        customerName
        customerCategory
        status
        creditLimit
        creditPeriod
        createdAt
        user {
          employeeName
        }
        addresses {
          id
          address
          latitude
          longitude
        }
      }
    }
  }
`;

export const getCustomermasterById = gql`
  query GetCustomerMasterById($id: ID!) {
    getCustomermasterById(id: $id) {
      success
      message
      error
      totalCount
      data {
        id
        customerCode
        customerName
        customerCategory
        status
        creditLimit
        creditPeriod
        addresses {
          id
          address
          latitude
          longitude
        }
      }
    }
  }
`;

export const filterCustomer = gql`
  query FilterCustomerMaster(
    $filters: CustomerMasterFilterInput
    $limit: Int
    $offset: Int
  ) {
    filterCustomermaster(filters: $filters, limit: $limit, offset: $offset) {
      success
      message
      error
      data {
        id
        customerCode
        customerName
        customerCategory
        status
        address1
        address1Lat
        address1Lng
        creditLimit
        creditPeriod
        createdAt
        lastUpdate
        createdBy
      }
    }
  }
`;

export const customerCategoryDropdown = gql`
query customerCategoryDropdown{
  customerCategoryDropdown {
    success
    error
    message
    data {
      id
      customerCategory
    }
  }
}`;
